import React, { useEffect } from 'react';
import { Box, Text } from '@chakra-ui/react';
import { Textarea, Input, PhoneInput } from 'formComponents';
import {
  FormValues,
  MasterInfo,
  ServiceGroupsInfo,
  SlotsPerMaster,
} from 'types';
import { useField, useFormState } from 'react-final-form';
import { find } from 'lodash-es';
import { Master } from 'components';
import { ContainerStyled } from './styles';
import { Services } from './Services';

const phoneMask = [
  '+',
  '7',
  '(',
  /[1-9]/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
];

export const Contacts: React.FC<{
  widgetId?: string;
  address: string;
  masters: MasterInfo[];
  possibleMastersIds?: string[];
  serviceGroups: ServiceGroupsInfo;
  slotsPerMaster?: SlotsPerMaster[];
  specialistCases: {
    specialistNominativeCase: string;
    specialistGenitiveCase: string;
    specialistPrepositionalCase: string;
  };
  fieldNameLabel: string;
  fieldCommentLabel: string;
}> = ({
  widgetId,
  address,
  masters,
  possibleMastersIds,
  serviceGroups,
  slotsPerMaster,
  specialistCases,
  fieldNameLabel,
  fieldCommentLabel,
}) => {
  const { input: masterIdInput } = useField<FormValues['masterId']>('masterId');
  const {
    values: { date, employeeId },
  } = useFormState<FormValues>();
  const ref = React.useRef<HTMLInputElement>();
  const { input: phoneInput } = useField('clientInfo.phone');

  const handleChangePhone = () => {
    if (ref?.current?.value) {
      phoneInput.onChange(ref.current.value);
    }
  };

  // masterId используется для хранения выбранного системой мастера,
  // если пользователь выбрал "Любой мастер".
  // Если был выбран "Любой мастер", то в masterIdInput записываем первого
  // "возможного" сотрудника в списке slotsPerMaster с выбранным временным слотом.
  // Иначе перекладываем employeeId в masterIdInput.
  useEffect(() => {
    if (employeeId === 'any') {
      const time = date.toTimeString().slice(0, 5);
      const masterId = find(
        slotsPerMaster,
        ({ times, employeeId: id }) =>
          typeof find(possibleMastersIds, (mId) => mId === id) !==
            'undefined' &&
          typeof find(times, (slot: string) => slot === time) !== 'undefined',
      )?.employeeId;
      masterIdInput.onChange(masterId);
    } else masterIdInput.onChange(employeeId);
  }, [date, employeeId, masterIdInput, possibleMastersIds, slotsPerMaster]);

  return (
    <ContainerStyled>
      <Box w="100%">
        <Master
          masters={masters}
          widgetId={widgetId}
          specialistCases={specialistCases}
        />
        <Services
          address={address}
          serviceGroups={serviceGroups}
          widgetId={widgetId}
        />
      </Box>
      <Box w="100%">
        <Text color="black" textStyle="h4" mb={-2}>
          Контактные данные
        </Text>
        <Input name="clientInfo.name" placeholder={fieldNameLabel ?? 'Имя'} />
        <PhoneInput
          mask={phoneMask}
          name="clientInfo.phone"
          placeholder="Телефон"
          type="tel"
          ref={ref as React.Ref<HTMLInputElement>}
          onChange={handleChangePhone}
        />
        <Textarea
          name="clientInfo.comment"
          placeholder={fieldCommentLabel ?? 'Комментарий'}
        />
      </Box>
    </ContainerStyled>
  );
};
